import {fetchSH} from '../api'

const getNamespaceByDomain = (domain) => fetchSH(`namespace-domain/domains/domain/${domain}`)
const getNamespaceConfig = (projectId) => fetchSH(`projects/${projectId}`)
const getNamespaceWithConfig = (projectIdOrDomain, lang) => fetchSH(`namespace-config/${projectIdOrDomain}${lang ? `?lang=${lang}` : ''}`)

export {
  getNamespaceByDomain, getNamespaceConfig, getNamespaceWithConfig
}
